import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { index } from '../../../store/actions/shopping.action'
import { changeScreen, changeScreenB, changeScreenC } from '../../../store/actions/navigation.action'
import { AppBar, Avatar, Toolbar, Button, CardHeader, CircularProgress, Drawer, IconButton, FormControl, FormControlLabel, Radio, RadioGroup, Typography, InputAdornment, TextField, FormLabel } from '@material-ui/core'
import { FcFilingCabinet } from 'react-icons/fc'
import { MdKeyboardBackspace, MdShoppingCart, MdDelete } from 'react-icons/md'
import { SCROLL } from '../../../config/App'

export default function Shopping(props) {
    const dispatch = useDispatch()
    const { shopping } = useSelector(state => state.shoppingReducer)
    const user_id = (props.user_id) ? props.user_id : null
    const screen = (props.screen) ? props.screen : null

    const [ isLoading, setLoading ] = React.useState(true)
    const [ isLoadMore, setLoadMore ] = React.useState(false)
    const [ menuEl, setMenu ] = React.useState(false)

    const date = new Date()
    const dateInit = new Intl.DateTimeFormat('pt-BR', {year: 'numeric'}).format(new Date(date))+'-'+ new Intl.DateTimeFormat('pt-BR', {month: '2-digit'}).format(new Date(date)) +'-'+new Intl.DateTimeFormat('pt-BR', {day: '2-digit'}).format(new Date(date))+'T00:00'
    const dateEnd = new Intl.DateTimeFormat('pt-BR', {year: 'numeric'}).format(new Date(date))+'-'+ new Intl.DateTimeFormat('pt-BR', {month: '2-digit'}).format(new Date(date)) +'-'+new Intl.DateTimeFormat('pt-BR', {day: '2-digit'}).format(new Date(date))+'T23:59'

    const [dateInitial, setDateInitial] = React.useState(null)
    const [dateFinal, setDateFinal] = React.useState(null)

    const [query, setQuery] = React.useState({ 
        page: 1,
        initial: dateInitial ? new Date(dateInitial) : null,
        final: dateFinal ? new Date(dateFinal) : null
    })

    const [form, setForm] = React.useState({
        status: 'all'
    });
    
    React.useEffect(() => {
        document.addEventListener('scroll', _handleScroll)
        return () => document.removeEventListener('scroll', _handleScroll)
        //eslint-disable-next-line react-hooks/exhaustive-deps
    })

    React.useEffect(() => {
        _index(isLoadMore)
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [query])

    React.useEffect(() => {
        if(isLoadMore) {
            setQuery({
                ...query,
                page: query.page + 1,
                initial: dateInitial ? new Date(dateInitial) : null,
                final: dateFinal ? new Date(dateFinal) : null
            })
        }
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoadMore])

    const _handleScroll = (event) => {
        const { scrollTop, scrollHeight, clientHeight } = event.srcElement.documentElement
        let scroll = scrollHeight - (clientHeight + scrollTop)
        if(scroll < SCROLL) {
            if(!isLoadMore && _handleLoadMore());
        }
    }

    const _handleLoadMore = () => {
        if(shopping.current_page < shopping.last_page) { 
            setLoadMore(true)
        }
    }

    const _index = (loadMore) => {
        dispatch(index(user_id, {...query, ...form}, loadMore)).then(res => {
            setLoading(false)
            setLoadMore(false)
        })
    }

    const handlePage = (page, uid) => {
        let data = {
            open: true,
            type: page,
            props: {
                user_id: user_id,
                uid: uid
            }
        }
        if(screen === 'b') {
            dispatch(changeScreenC(data))
        } else {
            dispatch(changeScreenB(data))
        }
    }

    return (
        <>
            <AppBar position="fixed">
                <Toolbar>
                    <IconButton 
                    onClick={() => {
                        if(screen === 'a') {
                            dispatch(changeScreen({ open: false }))
                        }
                        if(screen === 'b') {
                            dispatch(changeScreenB({ open: false }))
                        }
                    }} 
                    edge="start" color="inherit"
                    >
                        <MdKeyboardBackspace />
                    </IconButton>
                    <Typography variant="h6">
                        Compras
                    </Typography>

                    <Button onClick={() => setMenu(true)} color="inherit" className="ms-auto">
                        Filtrar
                    </Button>
                </Toolbar>
            </AppBar>

            <div className="mt-5 pt-1 bg-clear min-vh-100">

            {(isLoading) ? <div className="d-flex justify-content-center m-5 p-5"> <CircularProgress /> </div> :
                <>
                    <Drawer 
                        anchor="bottom"
                        open={menuEl}
                        onClose={() => setMenu(false)}
                    >
                        <div className="card card-body bs-bg">
                            <div className="mb-3">
                                <FormControl component="fieldset">
                                    <FormLabel className="bs-color" component="legend">Filtrar compras:</FormLabel>
                                    <RadioGroup
                                        name="order"
                                        value={form.status}
                                        onChange={ e => setForm({...form, status: e.target.value})}
                                        className="fw-normal bs-color-b"
                                    >
                                        <FormControlLabel value="all" control={<Radio color="primary" />} label="Todas" />
                                        <FormControlLabel value="active" control={<Radio color="primary" />} label="Ativas" />
                                        <FormControlLabel value="finished" control={<Radio color="primary" />} label="Finalizadas" />
                                    </RadioGroup>
                                </FormControl>
                            </div>

                            <hr className="invisible mt-2"/>

                            <div className="row mb-3">
                                <div className="col-6">
                                    <div className="date mb-3">
                                        <label className="label-date bs-color-b">
                                            {(dateInitial) && new Intl.DateTimeFormat('pt-BR', {year: 'numeric', month: '2-digit',day: '2-digit'}).format(new Date(dateInitial))}&nbsp;&nbsp;&nbsp;
                                            {(dateInitial) && new Intl.DateTimeFormat('pt-BR', {hour: '2-digit', minute: '2-digit'}).format(new Date(dateInitial))}    
                                        </label>
                                        <TextField
                                            id="datetime-local"
                                            label="Data Inicial"
                                            type="datetime-local"
                                            className="adornedEnd-p-0"
                                            defaultValue={dateInitial}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment className="pointer" position="end">
                                                        {dateInitial ?
                                                        <IconButton className="bs-color" onClick={() => setDateInitial(null)}>
                                                            <MdDelete size={18} />
                                                        </IconButton>
                                                        :
                                                        <></>
                                                        }
                                                    </InputAdornment>
                                                )
                                            }}
                                            onBlur={e => {
                                                if(e.target.value) {
                                                    setDateInitial(e.target.value)
                                                } else {
                                                    setDateInitial(dateInit)
                                                }
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className="date mb-3">
                                        <label className="label-date bs-color-b">
                                            {(dateFinal) && new Intl.DateTimeFormat('pt-BR', {year: 'numeric', month: '2-digit',day: '2-digit'}).format(new Date(dateFinal))}&nbsp;&nbsp;&nbsp;
                                            {(dateFinal) && new Intl.DateTimeFormat('pt-BR', {hour: '2-digit', minute: '2-digit'}).format(new Date(dateFinal))}    
                                        </label>
                                        <TextField
                                            id="datetime-local"
                                            label="Data Final"
                                            type="datetime-local"
                                            className="adornedEnd-p-0"
                                            defaultValue={dateFinal}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment className="pointer" position="end">
                                                        {dateFinal ?
                                                        <IconButton className="bs-color" onClick={() => setDateFinal(null)}>
                                                            <MdDelete size={18} />
                                                        </IconButton>
                                                        :
                                                        <></>
                                                        }
                                                    </InputAdornment>
                                                )
                                            }}
                                            onBlur={e => {
                                                if(e.target.value) {
                                                    setDateFinal(e.target.value)
                                                } else {
                                                    setDateFinal(dateEnd)
                                                }
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="col-12 mt-3 mb-2">
                                <div className="mb-3">
                                    <Button 
                                        fullWidth
                                        variant="contained" 
                                        color="primary"
                                        size="large"
                                        onClick={() => {
                                            setMenu(false)
                                            setLoading(true)
                                            dispatch(index(user_id, {
                                                ...query, 
                                                ...form, 
                                                page: 1,
                                                initial: dateInitial ? new Date(dateInitial) : null,
                                                final: dateFinal ? new Date(dateFinal) : null
                                            })).then(res => {
                                                setLoading(false)
                                                setLoadMore(false)
                                            })
                                        }}
                                    >
                                        Filtrar
                                    </Button>
                                </div>
                            </div>
                        </div>

                    </Drawer>

                    {(shopping.data.length < 1) &&
                        <div className="card card-body bs-bg mt-3">
                            <div className="text-center mt-5 pt-5 mb-5 pb-5">
                                <FcFilingCabinet size="70" />
                                <h6 className="mt-4 text-muted bs-color">Nenhum registro cadastrado</h6>
                            </div>
                        </div>
                    }

                    {(shopping.data.length > 0) &&
                        <>
                            <div className="card-body">
                                <label className="label-custom m-0 bs-color">{shopping.total.toLocaleString('pt-BR', {style: 'decimal'})} registro(s)</label>
                            </div>
                            
                            {shopping.data.map((item, index) => (
                                <div className="card pointer bs-bg list-items" key={index}>
                                    <CardHeader
                                        onClick={() => handlePage('transactions', item.id)}
                                        avatar={
                                            <Avatar>
                                                <MdShoppingCart />
                                            </Avatar>
                                        }
                                        title={<h6 className="fw-bold mb-1 bs-color-b">{item.title ? item.title.substring(0,25) : item.title}</h6>}
                                        subheader={<>
                                        {item.ganhador ? <small className="badge bg-danger">Encerrado</small> : <small className="badge bg-success">Ativa</small>}
                                        </>}
                                    />
                                    
                                </div>
                            ))}

                            {(isLoadMore) && <div className="text-center card-body"><CircularProgress /></div>}
                        </>
                    }
                </>
            }
            </div>
        </>
    )
}